// @flow
import React from "react";
import {
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
import ChangingProgressProvider from "./ChangingProgressProvider";
import AstrntLogo from "../../images/logo.svg";

type Props = {
  className: string
};

class LoaderNew extends React.Component<Props> {
  static defaultProps = {
    className: ""
  };

  render() {
    const { className,value } = this.props;

    return (
      <div className="page-loader-astrnt">
        <div className="loader-container">
          <CircularProgressbarWithChildren
            value={value}
            styles={buildStyles({
              // Rotation of path and trail, in number of turns (0-1)
              // rotation: 0.25,

              // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
              strokeLinecap: "round",

              // Text size
              // textSize: '16px',

              // How long animation takes to go from one percentage to another, in seconds
              pathTransitionDuration: 0.8,

              // Can specify path transition in more detail, or remove it entirely
              // pathTransition: 'none',

              // Colors
              pathColor: `#564FDB`,
              // textColor: '#f88',
              trailColor: "#E8E8E8"
              // backgroundColor: '#FFF',
            })}
          >
            {/* Put any JSX content in here that you'd like. It'll be vertically and horizonally centered. */}
            <img src={AstrntLogo} alt="Astrnt Logo" />
          </CircularProgressbarWithChildren>
        </div>
        {/* <span>Checking Connection...</span> */}
      </div>
    );
  }
}

export default LoaderNew;
